import { NavLink } from "react-router-dom";
import Lottie from "react-lottie";
import active from "../Lottie/activity.json";
import { motion } from "framer-motion";
import { TG_WEB_APP } from "../../App";
import UserStore from "../../store/user-store";

export const ServersStatusBtn = () => {
  const isRu = UserStore.langCode === "ru";
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        width: "100%",
        gap: 10,
      }}
    >
      <NavLink
        to="/status"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 8,
          border: "1px solid rgb(66, 68, 70)",
          padding: 5,
          backgroundColor: "rgb(22, 24, 26)",
          gap: 5,
          flex: 1,
          color: "white",
        }}
      >
        <Lottie
          style={{ height: 30, width: 30, margin: 0 }}
          speed={0.6}
          options={{
            loop: true,
            autoplay: true,
            animationData: active,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice",
            },
          }}
          height={20}
        />
        {isRu ? "Сервера" : "Servers"}
      </NavLink>
      <button
        onClick={() =>
          TG_WEB_APP.openTelegramLink(process.env.REACT_APP_SUPPORT_URL)
        }
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 8,
          border: "1px solid rgb(66, 68, 70)",
          backgroundColor: "rgb(22, 24, 26)",
          padding: 5,
          flex: 1,
          gap: 5,
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
        >
          <g clipPath="url(#clip0_1972_10835)">
            <path
              d="M20.066 12.1004C19.8071 11.7092 19.4529 11.4042 19.0458 11.2008C19.185 9.37367 18.6265 7.8465 17.776 7.7726L17.7449 7.76992C17.7048 6.22521 17.2033 4.69113 16.2685 3.3779C14.7628 1.26273 12.3393 0 9.78546 0C7.23158 0 4.80801 1.26273 3.30224 3.37797C2.36688 4.69227 1.86539 6.22724 1.82563 7.77302L1.79483 7.7756C0.930031 7.85084 0.363265 9.42617 0.528691 11.2938C0.694463 13.1621 1.53003 14.6153 2.39438 14.5401H2.39473L5.21637 14.2947C5.45426 14.274 5.6741 14.1605 5.82755 13.9792C5.9036 13.8894 5.96104 13.7856 5.99658 13.6738C6.03212 13.562 6.04507 13.4443 6.03468 13.3276L5.59285 8.34114C5.54913 7.85018 5.1123 7.4869 4.61672 7.53029L3.87033 7.59535C3.93762 6.52601 4.30184 5.47446 4.96646 4.54078C6.10801 2.93718 7.86432 2.01767 9.78543 2.01767C11.7064 2.01767 13.4628 2.93724 14.6044 4.54078C15.2686 5.4735 15.6322 6.52405 15.7002 7.59205L14.9541 7.52733C14.4586 7.48395 14.0217 7.84716 13.978 8.33818L13.5361 13.3246C13.5258 13.4414 13.5388 13.5591 13.5743 13.6709C13.6099 13.7827 13.6673 13.8864 13.7433 13.9762C13.8193 14.066 13.9124 14.1401 14.0173 14.1943C14.1222 14.2484 14.2368 14.2815 14.3546 14.2918L17.1762 14.5372H17.1765C17.8124 14.5924 18.4302 13.8173 18.7799 12.662C18.8332 12.7174 18.8873 12.7723 18.9306 12.838C19.0481 13.0147 19.1191 13.2177 19.1374 13.4285C19.1556 13.6393 19.1205 13.8513 19.0351 14.0452L18.1391 16.0875C18.006 16.3909 17.7864 16.6492 17.5072 16.8306C17.228 17.012 16.9013 17.1086 16.5674 17.1085H15.3615C15.2631 16.7945 14.9787 16.562 14.6294 16.562H12.3947C11.9652 16.562 11.617 16.9071 11.617 17.3327V18.2293C11.617 18.6549 11.9652 19 12.3947 19H14.6294C14.9787 19 15.2631 18.7675 15.3615 18.4535H16.5674C17.791 18.4535 18.8968 17.735 19.384 16.6233L20.2803 14.581C20.6361 13.7684 20.5562 12.8409 20.066 12.1004Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1972_10835">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
        {isRu ? "Поддержка" : "Support"}
      </button>
      <NavLink
        to="/instruction"
        style={{
          display: "flex",
          alignItems: "center",
          height: 42,
          justifyContent: "center",
          borderRadius: 8,
          border: "1px solid rgb(66, 68, 70)",
          backgroundColor: "rgb(22, 24, 26)",
          color: "white",
          padding: 5,
          flex: 1,
          gap: 5,
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M13 8V16C13 16.7956 12.6839 17.5587 12.1213 18.1213C11.5587 18.6839 10.7956 19 10 19H7.83C7.59409 19.6675 7.1298 20.2301 6.51919 20.5884C5.90858 20.9466 5.19098 21.0775 4.49321 20.9578C3.79545 20.8381 3.16246 20.4756 2.70613 19.9344C2.2498 19.3931 1.99951 18.708 1.99951 18C1.99951 17.292 2.2498 16.6069 2.70613 16.0656C3.16246 15.5244 3.79545 15.1619 4.49321 15.0422C5.19098 14.9225 5.90858 15.0534 6.51919 15.4116C7.1298 15.7699 7.59409 16.3325 7.83 17H10C10.2652 17 10.5196 16.8946 10.7071 16.7071C10.8946 16.5196 11 16.2652 11 16V8C11 7.20435 11.3161 6.44129 11.8787 5.87868C12.4413 5.31607 13.2044 5 14 5H17V2L22 6L17 10V7H14C13.7348 7 13.4804 7.10536 13.2929 7.29289C13.1054 7.48043 13 7.73478 13 8Z"
            fill="#E6E6E6"
          />
        </svg>
        {isRu ? "Инструкции" : "Instructions"}
      </NavLink>
    </motion.div>
  );
};
